// extracted by mini-css-extract-plugin
export default {"cover":"scale_cover__U-5RL"};